import React from 'react';

import { Images } from 'theme/images';

import { LegalContainer, LegalText, HollardLogo } from './styles';
/**
 * `Legals` is a functional component that renders a legal disclaimer and an image in the footer.
 *
 * @example
 * return (
 *   <Legals />
 * )
 */
export function Legals() {
  return (
    <LegalContainer>
      <LegalText>
        Naked Financial Technology Pty Ltd is an authorised Financial Services Provider (FSP 48822).
        Policies are underwritten by Hollard Specialist Insurance Limited, a Licensed Non-Life
        insurer and authorised Financial Services Provider (FSP 25511).
      </LegalText>
      <HollardLogo src={Images.hollardFooter} loading="lazy" />
    </LegalContainer>
  );
}
